
import qrCode from '~/components/j/qrCode.vue'
import viewDetails from '~/components/common/viewDetails'
import wikiFooter from '~/components/common/wikiFooter.vue'
import noData from '~/components/common/noData.vue'
import downTops from '~/components/home/downTops.vue' // 版权
let imgCheckPing = null
export default {
  name: 'DonwloadPage',
  components: {
    'no-data': noData,
    'wiki-footer': wikiFooter,
    'view-details': viewDetails,
    'qr-code': qrCode,
    'down-tops': downTops
  },
  layout: 'common',
  asyncData({ $api, app, store, route, req, res, $cookies, $serverlog, error }) {
    try {
      const downloadInit = $api.download.init({}).catch(() => {
        console.log('downloadInit')
      })
      let backHomeUrl = null
      let iosUrl = null
      let androidApk = null
      let qrCodeImg = null
      const wikifxIOS = null
      const fxeyeIOS = null
      const WikiFXapk = null
      const FXEYEapk = null
      let isWiki = true

      return Promise.all([downloadInit]).then((result) => {
        if (!result[0]) {
          res.statusCode = 404
          return {
            isShow404: true
          }
        } else {
          const linkAddress = {}
          result[0].forEach((el) => {
            // console.log(el)
            if (el.Type == 1) {
              // 国内apk
              linkAddress.FXEYEapk = el.LinkAddress
            }
            if (el.Type == 2) {
              // 国外apk
              linkAddress.WikiFXapk = el.LinkAddress
            }
            if (el.Type == 3) {
              // ios国内
              // linkAddress.fxeyeIOS = el.LinkAddress
              linkAddress.fxeyeIOS = 'https://apps.apple.com/cn/app/wikifx-hk-fpa/id6464009659'
            }
            if (el.Type == 4) {
              // ios 国外
              linkAddress.wikifxIOS = el.LinkAddress
            }
            if (el.Type == 5) {
              // 谷歌
              linkAddress.playGoogle = 'https://play.google.com/store/apps/details?id=com.foreigncurrency.internationalfxeye'
            }
            if (el.Type == 6) {
              linkAddress.fxeyePC = el.LinkAddress
            }
            if (el.Type == 7) {
              // *国内ios全球
              linkAddress.FXeye_golbal_ios = el.LinkAddress
            }
          })
          // wikifx
          backHomeUrl = `/${store.state.LanguageCode}`
          qrCodeImg = `https://resources1.interface003.com/web20/qrcode/www.${store.state.newhost}.com.png`
          if (store.state.isWiki == '1') {
            // if (req.headers.host.includes('110')) {
            iosUrl = linkAddress.wikifxIOS.replace('/es/', `/${store.state.getCountry?.twoCharCode.toLowerCase()}/`)
            // 下载wikifx apk安装包
            androidApk = linkAddress.WikiFXapk
          } else if (store.state.isWiki == '2' || store.state.isWiki == '4') {
            iosUrl = linkAddress.FXeye_golbal_ios
            // 从https://www.fxeye.uk/中进入，下载WikiFXapk安装包FXEYEapk1234
            androidApk = linkAddress.FXEYEapk
          } else if (store.state.isWiki == '3') {
            // this.$store.state.myCountry.toLowerCase() == 'cn'

            iosUrl = linkAddress.wikifxIOS.replace('/es/', `/${store.state.getCountry?.twoCharCode.toLowerCase()}/`)
            if (store.state.myCountry.toLowerCase() == 'cn') {
              androidApk = linkAddress.FXEYEapk
            } else {
              androidApk = linkAddress.FXEYEapk
            }
          }
          if (store.state.myCountry.toLowerCase() == 'cn') {
            // IP在国内谷歌在下,apk在上
            isWiki = false
          }
          // console.log(linkAddress)
          // const qrUrl = 'https://www.wikifx.com/en/download.html'
          // console.log(linkAddress, '地址')

          return {
            // qrUrl,
            linkAddress,
            backHomeUrl,
            iosUrl,
            androidApk,
            qrCodeImg,
            wikifxIOS,
            fxeyeIOS,
            WikiFXapk,
            FXEYEapk,
            isWiki,
            isChrome: false
          }
        }
      })
    } catch (err) {
      $serverlog(error(err).message)
    }
  },
  data() {
    return {
      isShowgoogle: false,
      isShowPWA: false,
      isWiki: '',
      qrUrl: '',
      qrShow: false,
      qrCodeImg: null, // 二维码
      linkAddress: {}, // 接口转换地址
      footContent: [
        {
          title: this.$v('平台信息 更多更全'),
          content: this.$v('基本资料、监管机构、点差表、隔夜利息等各类信息应有尽有'),
          id: '0'
        },
        {
          title: this.$v('平台真假 天眼鉴定'),
          content: `${this.$v('天眼评分，依托天眼大数据，多维度风险测评；软件鉴定，专业团队实时监测，让假冒无处可藏。')}`,
          id: '1'
        },
        {
          title: this.$v('关系族谱一览无余'),
          content: this.$v('让您想不到的台前幕后关系…'),
          id: '2'
        }
      ],
      resizeTimer: null, // 触发事件timer
      isShowIos: false, // 显示ios
      mask: false, // 遮罩层
      iosUrl: '', // ios大陆link
      androidApk: null, // apk
      wikiFxApk: null, // 国际apk
      fxEyeApk: null, // 安卓国内
      backHomeUrl: null, // 回到首页地址
      videoPause: true, // 视频暂停
      videoShow: false, // 展示视频
      isShow404: false, // 是否显示404
      wikifxIOS: '',
      fxeyeIOS: '',
      WikiFXapk: '',
      FXEYEapk: '',
      showTip: false // VX浏览器的遮罩层
    }
  },
  // tdk
  head() {
    return {
      title: this.$t('22028'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('22027')
        }
      ]
    }
  },
  computed: {
    CurLanForImg() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return 'zh'
      } else {
        return code
      }
    },
    isTraditional() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    },
    isZh() {
      return ['zh-cn', 'zh-tw', 'zh-hk', 'zh'].includes(this.$store.state.LanguageCode)
    },
    langType() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn') {
        return 'CN'
      } else if (code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return 'ZH'
      } else {
        return 'EN'
      }
    }
  },
  mounted() {
    // 调用异步函数
    this.checkGoogleAccess.call()
  },
  destroyed() {
    imgCheckPing = null
  },
  methods: {
    async checkGoogleAccess() {
      const that = this
      // 使用 Promise 包装 ipInChinaFn
      await new Promise((resolve, reject) => {
        that.ipInChinaFn(
          function () {
            // 可以访问google
            that.isShowgoogle = true
            resolve()
          },
          function () {
            // 不可以访问google
            that.isShowPWA = true
            resolve()
          }
        )
      })
      // 使用 nextTick 来确保 DOM 更新
      await this.$nextTick()
      // 设置二维码地址
      setTimeout(() => {
        this.qrUrl = this.$store.state.allHost
      }, 1500)
      // 执行其他异步方法
      this.IsIos()
      this.slideBanner()

      // 检查是否为 Chrome
      this.isChrome = this.isChromeFn()
      console.log('this.isChrome::: ', this.isChrome)
    },
    ipInChinaFn(func1, func2) {
      const that = this
      let hasFinish = false

      imgCheckPing = new Image()
      const src = that.GetNewUrl()
      imgCheckPing.src = src
      imgCheckPing.onload = function () {
        if (!hasFinish) {
          this.ss += 'p-333,'
          hasFinish = true
          console.log('Ping ' + src + ' success. ')
          func1()
        }
      }
      imgCheckPing.onerror = function () {
        if (!hasFinish) {
          this.ss += 'p-666,'
          hasFinish = true
          console.log('Ping ' + src + ' error. ')
          func2()
        }
      }
      setTimeout(function () {
        if (!hasFinish) {
          this.ss += 'p-eee,'
          hasFinish = true
          console.log('Ping ' + src + ' timeout(0.5s). ')
          imgCheckPing.src = 'https://resources1.interface003.com/web20/img/favicon-wikifx.ico'
          func2()
        }
      }, 500)
    },
    GetNewUrl() {
      return 'https://www.google.com/favicon.ico?' + Math.random()
    },
    isChromeFn() {
      const isChromium = window.chrome
      const winNav = window.navigator
      const vendorName = winNav.vendor
      const isOpera = typeof window.opr !== 'undefined'
      const isIEedge = winNav.userAgent.includes('Edg')
      const isIOSChrome = winNav.userAgent.match('CriOS')
      let isGoogleChrome = false

      if (typeof winNav?.userAgentData !== 'undefined') {
        const { brands } = winNav.userAgentData
        console.log('brands', brands)
        if (brands && brands.length > 0) {
          const hasGoogleChrome = brands.some((brand) => brand.brand === 'Google Chrome')
          const hasChromium = brands.some((brand) => brand.brand === 'Chromium')
          if (hasGoogleChrome && hasChromium) {
            isGoogleChrome = true
          }
        }
      } else if (vendorName === 'Google Inc.') {
        isGoogleChrome = true
      }

      // console.log('isChromium', isChromium)
      // console.log('winNav', winNav)
      // console.log('vendorName', vendorName)
      // console.log('isOpera', isOpera)
      // console.log('isIEedge', isIEedge)
      // console.log('isIOSChrome', isIOSChrome)
      // console.log('isGoogleChrome', isGoogleChrome)

      if (winNav.userAgentData) {
        console.log('winNav.userAgentData', winNav.userAgentData)
      }
      if (winNav.userAgentData && winNav.userAgentData.brands) {
        console.log('winNav.userAgentData.brand', winNav.userAgentData.brands)
      }

      if (isIOSChrome) {
        // is Google Chrome on IOS
        console.log('is Google Chrome on IOS')
        return false
      } else if (isChromium !== null && typeof isChromium !== 'undefined' && vendorName === 'Google Inc.' && isOpera === false && isIEedge === false && isGoogleChrome) {
        // is Google Chrome
        console.log('is Google Chrome')
        return true
      }
      // not Google Chrome
      console.log('not Google Chrome')
      return false
    },
    openapktipsfn() {
      this.$refs.bqtops.open()
      // window.open(this.androidApk)
    },
    isWeChat() {
      // 判断是否为微信浏览器
      const { userAgent } = navigator
      const isWeixin = !!/MicroMessenger/i.test(userAgent)
      if (isWeixin) {
        // 如果是微信环境，就弹出遮罩层
        this.showTip = true
      }
    },
    openVideo() {
      // 打开视频
      this.$refs.viewDetails.open()
    },
    // 判断ios or android
    IsIos() {
      const u = navigator.userAgent
      const isAndroid = u.includes('Android') || u.includes('Linux')
      // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (isAndroid) {
        // 这个是安卓操作系统
        this.isShowIos = false
        // alert('安卓机！')
      } else {
        // 这个是ios操作系统
        this.isShowIos = true
        // alert('苹果果机！')
      }
    },
    // 轮播图手滑
    slideBanner() {
      // 选中的轮播图
      const box = document.querySelector('.el-carousel__container')
      if (!box) return
      let startPoint = 0
      let stopPoint = 0
      // 重置坐标
      const resetPoint = function () {
        startPoint = 0
        stopPoint = 0
      }
      // 手指按下
      box.addEventListener(
        'touchstart',
        function (e) {
          // 手指点击位置的X坐标
          startPoint = e.changedTouches[0].pageX
        },
        { passive: true }
      )
      // 手指滑动
      box.addEventListener(
        'touchmove',
        function (e) {
          // 手指滑动后终点位置X的坐标
          stopPoint = e.changedTouches[0].pageX
        },
        { passive: true }
      )
      // 当手指抬起的时候，判断图片滚动离左右的距离
      const that = this
      box.addEventListener(
        'touchend',
        function (e) {
          if (stopPoint == 0 || startPoint - stopPoint == 0) {
            resetPoint()
            return
          }
          if (startPoint - stopPoint > 0) {
            resetPoint()
            that.$refs.slideCarousel.next()
            return
          }
          if (startPoint - stopPoint < 0) {
            resetPoint()
            that.$refs.slideCarousel.prev()
          }
        },
        { passive: true }
      )
    },
    sensorDownloadType(type) {
      // this.sensorTrack(type)
    }
  }
}
